/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmConversationsUpdate } from "../../funcs/llmConversationsUpdate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ConversationsUpdateRequest$inboundSchema,
};

export const tool$llmConversationsUpdate: ToolDefinition<typeof args> = {
  name: "llm-conversations-update",
  description: `Update a conversation

Update a conversation's metadata.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmConversationsUpdate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
